import Noty from './../../../public/limitless/global_assets/js/plugins/notifications/noty.min.js'

export default class MessageNotificator {

    #show(message, type, buttons = false) {
        return new Noty({
            theme: 'limitless',
            layout: type === 'info' ? "bottomRight" : "topRight",
            text: message,
            type: type,
            modal: !!buttons,
            timeout: buttons ? false : 2500,
            buttons: buttons ? buttons : false
        }).show();
    }

    confirm(message, callBack) {
        let noty = this.#show(message, 'confirm', [
            Noty.button(`${translate('buttons.close')}`, 'btn bg-light', function () {
                noty.close();
            }),

            Noty.button(`${translate('buttons.confirm')}`, 'btn bg-danger ml-1', function () {
                // Disabling the confirmation button to prevent double-clicking
                let confirmButtonId = noty.options.buttons[1].id;
                let confirmButton = document.getElementById(confirmButtonId);

                confirmButton.setAttribute("disabled", true);
                
                callBack();
                noty.close();
            })
        ])
    }

    successConfirm(message, callBack) {
        let noty = this.#show(message, 'confirm', [
            Noty.button(`${translate('buttons.close')}`, 'btn bg-light', function () {
                noty.close();
            }),

            Noty.button(`${translate('buttons.confirm')}`, 'btn bg-primary ml-1', function () {
                // Disabling the confirmation button to prevent double-clicking
                let confirmButtonId = noty.options.buttons[1].id;
                let confirmButton = document.getElementById(confirmButtonId);

                confirmButton.setAttribute("disabled", true);
                
                callBack();
                noty.close();
            })
        ]) 
    }

    success(message) {
        this.#show(message, 'success')
    }

    error(message) {
        this.#show(message, 'error')
    }

    warning(message) {
        this.#show(message, 'warning')
    }

    information(message) {
        this.#show(message, 'info')
    }

    alert(message) {
        this.#show(message, 'alert')
    }
}
